import * as React from 'react';
import classnames from 'classnames';

const HorizontalImageSlider = ({ activeImage , images , onClick  })=>{
     return React.createElement("div", {
        className: "horizontal-image-slider"
    }, images.map((image)=>{
         return React.createElement("button", {
            type: "button",
            onClick: ()=>onClick(image)
            ,
            key: `${image.label}-thumb`,
            className: classnames('horizontal-image-slider__button', {
                'horizontal-image-slider__button--active': (activeImage === null || activeImage === void 0 ? void 0 : activeImage.label) === image.label,
                'horizontal-image-slider__button--highlighted': image.highlighted
            })
        }, /*#__PURE__*/ React.createElement("div", {
            className: "aspect-wrapper"
        }, /*#__PURE__*/ React.createElement("picture", {
            className: "horizontal-image-slider__picture"
        }, /*#__PURE__*/ React.createElement("source", {
            srcSet: image.thumbnailUrl,
            media: "(max-width: 1024px)"
        }), /*#__PURE__*/ React.createElement("img", {
            src: image.url,
            className: "horizontal-image-slider__image",
            alt: image.altText
        }))));
    }));
};

export { HorizontalImageSlider };
//# sourceMappingURL=HorizontalImageSlider.js.map
